module.exports = __webpack_public_path__ + "img/2Z.17a83aae.jpg";